import { render, staticRenderFns } from "./LivingWill.vue?vue&type=template&id=711b58ec&scoped=true"
import script from "./LivingWill.vue?vue&type=script&lang=js"
export * from "./LivingWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b58ec",
  null
  
)

export default component.exports